import { render, staticRenderFns } from "./CustomerTypeSelect.vue?vue&type=template&id=260c8d21&scoped=true&"
import script from "./CustomerTypeSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c8d21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
